import { Container, Image, Row } from "react-bootstrap";
import "../../../assets/scss/components/sections/library/resume/resume.scss";
import SingleResume from "./singleResume";
import Pagination from "../../../components/templates/pagination";
import { loaderResumes, resumeFilters, resumes } from "../data/data";
import "../../../assets/scss/components/sections/library/header.scss";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { downloadButtonClicked, showToast } from "../../../utils/commonHelper";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import leftScroll from "../../../assets/images/home/left-scroll.svg";
import rightScroll from "../../../assets/images/home/right-scroll.svg";
// import { autoComplete_job_titles } from "./helper";

const data = [
  { label: "Marketing sales", count: 23 },
  { label: "Market research", count: 12 },
  { label: "Market development", count: 8 },
  { label: "Market strategies", count: 5 },
];

const highlightText = (text, query) => {
  const parts = text.split(new RegExp(`(${query})`, "gi"));
  return parts.map((part, i) =>
    part.toLowerCase() === query.toLowerCase() ? (
      <mark key={i}>{part}</mark>
    ) : (
      part
    )
  );
};
const Resumes = ({ isLoading, resumesData, onFamilyChange, onPageChange }) => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPage, setCurrentPage] = useState(resumesData?.current_page);
  const [resumesPerPage, setResumesPerPage] = useState(8);
  const [activePlan, setActivePlan] = useState("All");
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadButtonLoadingState, setDownloadButtonLoadingState] = useState(
    []
  );
  const sliderRef = useRef(null);

  const lastPageIndex = currentPage * resumesPerPage;
  const firstPageIndex = lastPageIndex - resumesPerPage;
  const currentResumes = resumes.slice(firstPageIndex, lastPageIndex);

  const handleFamilyChange = (plan) => {
    setActivePlan(plan.job_family);
    onFamilyChange(plan);
  };

  const handlePrevClick = () => {
    if (currentIndex > 0) {
      sliderRef.current.slickPrev();
      setCurrentIndex((prev) => prev - 1);
    }
  };

  const handleNextClick = () => {
    if (currentIndex < (resumesData?.job_families?.length || 0)) {
      sliderRef.current.slickNext();
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const sliderSettings = {
    className: "slider variable-width",
    dots: false,
    infinite: false,
    speed: 500,
    slidesToScroll: 3,
    variableWidth: true,
    afterChange: (current) => {
      setCurrentIndex(current);
    },
    responsive: [
      {
        breakpoint: 573,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
          variableWidth: true,
          centerMode: false,
          centerPadding: "20px",
        },
      },
    ],
  };

  const isPrevDisabled = currentIndex === 0;
  const isNextDisabled =
    currentIndex >= (resumesData?.job_families?.length || 0);

  return (
    <Container>
      {isLoading ? (
        <div className="loading">
          <div className="resume-switch-buttons text-center mb-4">
            {resumeFilters.map((plan) => (
              <button
                key={plan}
                className={`resumes-filter-btn shimmer`}
              ></button>
            ))}
          </div>

          <div className="library-resumes">
            <Row>
              {loaderResumes.map((resume, i) => (
                <SingleResume
                  level={resume.level}
                  resumeTitle={resume.resumeTitle}
                  company={resume.company}
                  isLoading={isLoading}
                />
              ))}
            </Row>
          </div>
        </div>
      ) : (
        <div>
          {resumesData?.resumes.length > 0 ? (
            <>
              <div className="category-wrapper">
                <button
                  className={`nav-arrow left-arrow ${
                    isPrevDisabled ? "disabled" : ""
                  }`}
                  onClick={handlePrevClick}
                  disabled={isPrevDisabled}
                >
                  <Image src={leftScroll} />
                </button>

                <Slider
                  {...sliderSettings}
                  ref={sliderRef}
                  className="resume-switch-buttons text-center mb-4"
                >
                  {[
                    { job_family: "All", count: resumesData?.total_count },
                    ...resumesData?.job_families,
                  ].map((plan) => (
                    <button
                      key={plan.job_family}
                      className={`resumes-filter-btn ${
                        activePlan === plan.job_family ? "active" : ""
                      }`}
                      onClick={() => handleFamilyChange(plan)}
                    >
                      {plan.job_family}{" "}
                      <span className="total-filtered-resumes">
                        {plan.count}
                      </span>
                    </button>
                  ))}
                </Slider>

                <button
                  className={`nav-arrow right-arrow ${
                    isNextDisabled ? "disabled" : ""
                  }`}
                  onClick={handleNextClick}
                  disabled={isNextDisabled}
                >
                  <Image src={rightScroll} />
                </button>
              </div>

              <div className="resume-switch-buttons mobile text-center mb-4">
                {[
                  { job_family: "All", count: resumesData?.total_count },
                  ...resumesData?.job_families,
                ].map((plan) => (
                  <button
                    key={plan.job_family}
                    className={`resumes-filter-btn ${
                      activePlan === plan.job_family ? "active" : ""
                    }`}
                    onClick={() => handleFamilyChange(plan)}
                  >
                    {plan.job_family}{" "}
                    <span className="total-filtered-resumes">{plan.count}</span>
                  </button>
                ))}
              </div>

              <div className="library-resumes">
                <Row>
                  {resumesData?.resumes.map((resume, i) => (
                    <SingleResume
                      level={resume?.metadata?.career_level}
                      resumeTitle={resume?.metadata?.job_title}
                      company={resume?.metadata?.industry}
                      isLoading={isLoading}
                      resumeImg={resume?.resume_thumbnail_url}
                      handleResumeClick={() =>
                        navigate(
                          `/resume-details/${resume?.metadata?.slug}/${resume?._id}`
                        )
                      }
                      singleResumeDownlaod={() =>
                        downloadButtonClicked(
                          resume?.resume_file_url,
                          resume?.metadata?.slug,
                          resume?._id,
                          setIsDownloading,
                          navigate,
                          setDownloadButtonLoadingState
                        )
                      }
                      isDownloading={
                        downloadButtonLoadingState[resume.resume_file_url]
                      }
                    />
                  ))}
                </Row>
                <Pagination
                  totalPages={resumesData?.total_pages}
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage}
                  isBackwardDisabled={resumesData?.has_prev}
                  isForwardDisabled={resumesData?.has_next}
                  onPageChange={(pageNumber) => onPageChange(pageNumber)}
                />
              </div>
            </>
          ) : (
            <h3 className="text-center">No Resume Found</h3>
          )}
        </div>
      )}
    </Container>
  );
};

export default Resumes;
